import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiGetReunionList, apiIsLoggedIn } from '../api/api';
import '../styles/reunionpage.css';
import TopBarReunion from '../components/topbars/TopBarReunion';
import ReunionPhoto from '../components/tables/ReunionPhotos/ReunionPhoto';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class ReunionPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reunions: [],
        }
    }
    
    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            }
        }).catch(error => {
            console.error('Error checking login status:', error);
            window.location.href = '/';
        });

        apiGetReunionList().then(response => {
            if (response.ok) {
                response.json().then(data => {
                    this.setState({
                        reunions: data.reunions,
                    });
                }).catch(error => {
                    console.error('Error parsing reunion list: ', error);
                });
            } else {
                throw new Error('Failed to fetch reunion list')
            }
        })
    }

    render() {
        let thisReunion = {};
        for (let reunion of this.state.reunions) {
            if (this.props.params.year === reunion.Year) {
                thisReunion = reunion;
            }
        }

        return (
            <div>
                <TopBarReunion />
                <div className='reunion-page'>
                    <h1>{thisReunion.Year}: {thisReunion.City}, {thisReunion.Country}</h1>

                    <h2><Link to={`/reunionPhotos/${thisReunion.Folder}`}>View Photos</Link></h2>
                    {thisReunion.FamilyPhoto ?
                        <ReunionPhoto photoUri={`${thisReunion.Folder}/${thisReunion.FamilyPhoto}`} style={{width: 1000, hieght: '100%'}}/>
                    : null}
                </div>
            </div>
        );
    }
}

export default withParams(ReunionPage);
